// extracted by mini-css-extract-plugin
export default {"consultationHost":"styles_consultationHost__kk3r1"};